import { BaseField } from './BaseField';

const imgWarstwa1 = "/assets/e23fb58bac7850907c8029b82ab2616632141341.svg";

export class AreaField extends BaseField {
  constructor() {
    super({
      key: 'area',
      icon: imgWarstwa1,
      defaultLabel: 'Metraż'
    });
  }

  renderForList(property) {
    return {
      label: this.defaultLabel,
      value: `${property.specifications.area.total} m²`
    };
  }

  renderForCard(property) {
    return {
      label: this.defaultLabel,
      value: `${property.specifications.area.total} ${property.specifications.area.unit}`
    };
  }
}
